<template>
  <div v-loading="loading" class="public-View">
    <div class="public-goback">
      <img alt :src="g_imgSrc.rightArrow" class="public-goback-img" @click="goback" />
      <div class="public-goback-return" @click="goback">返回</div>
    </div>
    <div class="public">
      <el-form
        ref="topForm"
        class="form_box"
        :inline="true"
        :model="paper_info"
        :rules="rules"
        label-position="left"
      >
        <el-form-item label="考试名称：" prop="paper_name">
          <el-input
            class="middle-input"
            v-model.trim="paper_info.paper_name"
            placeholder="请输入"
            :maxlength="16"
            show-word-limit
            clearable
          />
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input
            class="long-input"
            v-model.trim="paper_info.remark"
            placeholder="请输入"
            :maxlength="32"
            show-word-limit
            clearable
          />
        </el-form-item>
      </el-form>
      <QuestionList
        :q-list="paper_content"
        @changeComponent="changeComponent"
        @saveChange="saveChange"
        @setGrossScore="setGrossScore"
        v-if="showQuestionList"
        ref="questionList"
      ></QuestionList>
      <el-form
        ref="bottomForm"
        class="form_box"
        style="margin-top: 24px"
        :inline="true"
        :model="paper_info"
        :rules="rules"
        label-position="left"
      >
        <el-form-item class="row short-margin-bottom" label="试卷有效时间：">
          <el-date-picker
            v-model="paperTime"
            :editable="false"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
          ></el-date-picker>
        </el-form-item>
        <el-form-item class="row short-margin-bottom" label="考试范围：" label-width="108px">
          <SelectViewRange
            ref="viewRangeTab"
            :user-id-list="paper_info.staff_scope.scope_user_id || []"
            :department-id-list="paper_info.staff_scope.scope_department_id || []"
            :disable-select-all="true"
          ></SelectViewRange>
        </el-form-item>
        <el-form-item
          class="long-margin-right"
          label="选项乱序："
          label-width="108px"
          prop="order_type"
        >
          <el-switch
            v-model="paper_info.order_type"
            :active-value="2"
            :inactive-value="1"
            active-color="rgb(47, 150, 255)"
            inactive-color="#888"
          ></el-switch>
        </el-form-item>
        <el-form-item
          class="long-margin-right"
          label="考试时间："
          label-width="108px"
          prop="time_interval"
        >
          <el-input
            class="short-input"
            v-model.number="paper_info.time_interval"
            placeholder="输入时间"
            :maxlength="3"
          />
          分钟
        </el-form-item>
        <el-form-item
          class="long-margin-right"
          label="考试次数："
          label-width="108px"
          prop="max_taken_count"
        >
          <el-input
            class="short-input"
            v-model.number="paper_info.max_taken_count"
            placeholder="输入次数"
            :maxlength="2"
          />
          次
        </el-form-item>
        <el-form-item
          :label="`及格分数(总分：${grossScore})：`"
          label-width="180px"
          prop="pass_mark"
        >
          <el-input
            class="short-input"
            v-model.number="paper_info.pass_mark"
            placeholder="输入分数"
            :maxlength="3"
          />
          分
        </el-form-item>
        <br />
        <el-form-item
          v-if="paperTime[0]"
          class="long-margin-right"
          label="考试提醒："
          label-width="108px"
          prop="is_remind"
        >
          <el-switch
            v-model="paper_info.is_remind"
            :active-value="1"
            :inactive-value="0"
            active-color="rgb(47, 150, 255)"
            inactive-color="#888"
          ></el-switch>
        </el-form-item>
        <el-form-item
          v-if="paper_info.is_remind"
          label="提醒时间："
          label-width="108px"
          prop="remind_hour"
          inline
        >
          考试开始前
        </el-form-item>
        <el-form-item v-if="paper_info.is_remind" class="long-margin-right" prop="remind_time2">
          <el-input
            class="short-input"
            v-model.number="paper_info.remind_hour"
            placeholder=""
            :min="0"
          />
          小时
        </el-form-item>
        <el-form-item v-if="paper_info.is_remind" prop="remind_minute">
          <el-input class="short-input" v-model.number="paper_info.remind_minute" placeholder="" />
          分钟进行提醒
        </el-form-item>
        <el-form-item class="row" label="标签：" label-width="108px">
          <LabelSelect
            class="label-box"
            :label-amount="10"
            :tags="paper_info.attach_labels"
            ref="labelSelect"
          ></LabelSelect>
        </el-form-item>
        <div class="save_button">
          <el-button @click="goback()" class="pubic-button">取消</el-button>
          <el-button type="primary" @click="handleSubmit()" class="pubic-button">保存</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import {
  CreateExaminationPaper,
  UpdateExaminationPaper,
  GetExaminationPaperById,
} from '@/api/exam.js';
import QuestionList from '../components/questionList';
import SelectViewRange from '@/components/selectViewRange';
import LabelSelect from '@/components/labelSelect';
import { mapQuery } from '@/utils/util';
import { lstore } from '@/libs/utils/util';
// import moment from 'moment';

export default {
  name: 'ManagerDetails',
  components: {
    QuestionList,
    SelectViewRange,
    LabelSelect,
  },
  data() {
    return {
      loading: false, // 加载状态
      paper_info: {
        paper_name: '',
        remark: '',
        start_time: '',
        stop_time: '',
        time_interval: '',
        max_taken_count: '',
        pass_mark: '',
        staff_scope: {
          scope_department_id: [],
          scope_user_id: [],
        },
        attach_labels: [],
        is_remind: 0, // 是否进行企业微信消息-考试提醒 0-不提醒 1-提醒
        remind_time: undefined, // 提醒时间 秒
        remind_hour: 0, // 提醒小时
        remind_minute: 0, // 提醒分钟
      },
      paper_content: [],
      form: {
        name: null, // 公共号名称
        phone: null, // 手机号
        WeChat: null, // 微信
        role: null, // 角色信息
        publistValue: [], // 公众号
        agentValue: [], // 企业应用
      },
      showQuestionList: false,
      paperTime: [,],
      grossScore: 0,
      // 管理员 操作员列表
      characterList: [
        {
          id: 1,
          label: '管理员',
          disabled: false,
          total: 3,
          count: 0,
        },
        {
          id: 2,
          label: '操作员',
          total: 99,
          disabled: false,
          count: 0,
        },
      ],
      // 校验规则
      rules: {
        paper_name: [
          {
            required: true,
            message: '请输入考试名称',
            trigger: 'blur',
          },
          {
            required: true,
            pattern: /^((?![!#%+/?\\&]).)*$/,
            message: '考试名称不支持特殊字符!#%+/?\\&',
            trigger: 'blur',
          },
        ],
        time_interval: [
          {
            required: true,
            message: '请输入考试时间',
            trigger: 'blur',
          },
          {
            type: 'integer',
            min: 1,
            message: '必须为正整数',
            trigger: 'blur',
          },
        ],
        max_taken_count: [
          {
            required: true,
            message: '请输入考试次数',
            trigger: 'blur',
          },
          {
            type: 'integer',
            min: 1,
            message: '必须为正整数',
            trigger: 'blur',
          },
        ],
        pass_mark: [
          {
            required: true,
            message: '请输入及格分数',
            trigger: 'blur',
          },
          {
            type: 'integer',
            min: 1,
            message: '必须大于0小于考试总分',
            trigger: 'blur',
          },
        ],
        remind_hour: [
          {
            required: true,
            message: '请输入提醒时间/时',
            trigger: 'blur',
          },
          // {
          //   type: 'integer',
          //   min: 0,
          //   message: '必须为正整数',
          //   trigger: 'blur',
          // },
        ],
        remind_time2: [
          {
            type: 'integer',
            min: 0,
            message: '必须为正整数',
            trigger: 'blur',
          },
          // {
          //   type: 'integer',
          //   min: 0,
          //   message: '必须为正整数',
          //   trigger: 'blur',
          // },
        ],
        remind_minute: [
          {
            type: 'integer',
            min: 0,
            max: 60,
            message: '必须为0～60之间的正整数',
            trigger: 'blur',
          },
        ],
      },
      paper_id: undefined,
      type: undefined,
    };
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      if (this.$route.query.paper_id) this.paper_id = this.$route.query.paper_id;
      if (this.$route.query.type) this.type = this.$route.query.type;
      if (this.type === 'back') {
        const paperInfo = lstore.getItem('exam-paper-info');
        if (paperInfo) this.paper_info = paperInfo;
        this.getPaperInfo();
      }
      const breadcrumb = [
        { menu_name: '考试管理', menu_path: '' },
        { menu_name: '试卷管理', menu_path: 'examPaperManagement' },
      ];
      let menuName = '新建考卷';
      if (this.paper_id) {
        menuName = '编辑考卷';
        if (this.type !== 'back') {
          this.getExamPaper();
        } else {
          this.showQuestionList = true;
        }
      } else {
        this.showQuestionList = true;
      }
      breadcrumb.push({ menu_name: menuName });
      this.g_breadcrumb(breadcrumb);
    },
    getExamPaper() {
      GetExaminationPaperById({ paper_id: this.paper_id }).then((res) => {
        // 提醒时间前端显示 [试卷有效时间 - 提醒分钟数 (以时间戳方式计算, 秒级)]
        // 得到时间后分解为小时和分钟数量
        res.paper_info.remind_time = (res.paper_info.start_time - res.paper_info.remind_time) / 60;
        res.paper_info.remind_hour = Math.floor(res.paper_info.remind_time / 60);
        res.paper_info.remind_minute = res.paper_info.remind_time % 60;
        // res.paper_info.remind_time = this.pullRemindTime({
        //   publicTime: res.paper_info.start_time,
        //   remindTime: res.paper_info.remind_time,
        // });
        this.paper_info = res.paper_info;

        this.paper_content = res.paper_content || [];
        this.getPaperInfo();
        this.showQuestionList = true;
        if (!this.paper_info.staff_scope) this.paper_info.staff_scope = {};
        this.$refs.viewRangeTab.setChecked(
          this.paper_info.staff_scope.scope_user_id,
          this.paper_info.staff_scope.scope_department_id,
          this.paper_info.staff_scope.scope_tag_id,
        );
      });
    },
    closeConfirmForm() {
      this.publicVisible = false;
    },
    confirmForm() {
      if (this.htmlType === 1) {
        this.confirmDialogVisible = true;
      } else {
        this.submitForm();
      }
    },
    changeComponent(componentName, query) {
      this.componentName = componentName;
      const url = `/saas/examPaperManagement.html${mapQuery({ componentName, ...query })}`;
      console.log(url);
      this.g_tourl(url, {});
    },
    // 表单校验
    checkForm() {
      let flag = true;
      this.$refs.topForm.validate((valid) => {
        flag = flag && valid;
      });
      this.$refs.bottomForm.validate((valid) => {
        flag = flag && valid;
      });
      if (this.$refs.questionList.isEmpty()) {
        this.$message.error('请选择至少一道题目');
        return false;
      }
      if (!this.paperTime[1] || this.paperTime[1] < new Date().getTime()) {
        this.$message.error('结束时间需晚于现在');
        return false;
      }
      if (!this.$refs.viewRangeTab.hasSelection) {
        this.$message.error('请选择考试范围');
        return false;
      }
      if (this.$refs.labelSelect.commitTags().length > 10) {
        this.$message.warning('标签数量不能多于10个');
        return false;
      }
      if (
        this.paper_info.is_remind === 1 &&
        this.paper_info.remind_hour === 0 &&
        this.paper_info.remind_minute === 0
      ) {
        this.$message.warning('考试提醒的提前时间不得少于1分钟');
        return false;
      }
      return flag;
    },
    // 保存
    handleSubmit() {
      this.rules.pass_mark[1].max = this.$refs.questionList.getCredit();
      if (!this.checkForm()) return;
      this.setPaperInfo();

      const paperInfo = JSON.parse(JSON.stringify(this.paper_info));

      // 提醒时间后端传参 [试卷有效时间 - 提醒分钟数 (以时间戳方式计算, 秒级)]
      paperInfo.remind_time =
        this.paper_info.start_time -
        (this.paper_info.remind_hour * 60 + this.paper_info.remind_minute) * 60;
      // paperInfo.remind_time = this.pushRemindTime({
      //   publicTime: this.paper_info.start_time,
      //   remindTime: paperInfo.remind_time,
      // });
      // if (paperInfo.is_remind && !paperInfo.remind_time) {
      //   this.$message.warning('请输入提醒时间');
      //   return;
      // }
      // if (paperInfo.remind_time) {
      //   paperInfo.remind_time *= 60;
      // } else {
      //   paperInfo.remind_time = undefined;
      // }

      const params = {
        paper_id: this.paper_id,
        paper_info: paperInfo,
        set_value_type: 1, // 手工设置每道题分值
        single_choice_list: this.$refs.questionList.getRadioList(),
        multiple_choice_list: this.$refs.questionList.getCheckboxList(),
        batch_fixed_value: {
          single_choice_vaule: 0,
          multiple_choice_vaule: 0,
        },
      };
      if (this.paper_id) {
        UpdateExaminationPaper(params)
          .then((res) => {
            console.log(res);
            this.$message.success('保存成功');
            this.goback();
          })
          .catch(() => {
            this.$message.error('保存失败');
          });
      } else {
        CreateExaminationPaper(params)
          .then((res) => {
            console.log(res);
            this.$message.success('创建成功');
            this.goback();
          })
          .catch(() => {
            this.$message.error('创建失败');
          });
      }
    },
    setPaperInfo() {
      const staffInfo = this.$refs.viewRangeTab.submitForm();
      this.paper_info.staff_scope = {
        scope_user_id: staffInfo.userIds,
        scope_department_id: staffInfo.departIds,
        scope_tag_id: staffInfo.labelIds,
      };
      this.$set(
        this.paper_info,
        'attach_labels',
        this.$refs.labelSelect.commitTags().map((item) => {
          return { tag_id: item.TagId, tag_type: item.TagType };
        }),
      );
      [this.paper_info.start_time, this.paper_info.stop_time] = this.paperTime || [
        undefined,
        undefined,
      ];
      this.paper_info.start_time /= 1000;
      this.paper_info.stop_time /= 1000;
    },
    getPaperInfo() {
      this.paperTime = [
        this.paper_info.start_time * 1000 || undefined,
        this.paper_info.stop_time * 1000 || undefined,
      ];
      this.paper_info.attach_labels = this.paper_info.attach_labels.map((item) => {
        return { TagId: item.tag_id, TagType: item.tag_type };
      });
    },
    saveChange() {
      this.setPaperInfo();
      lstore.setItem('exam-paper-info', this.paper_info);
    },
    setGrossScore(val) {
      this.grossScore = val;
    },
    // 返回
    goback() {
      this.$refs.questionList.removeLstore();
      lstore.removeItem('exam-paper-info');
      this.$emit('changeComponent', 'paperList');
    },
    // // 提醒时间后端传参 [试卷有效时间 - 提醒分钟数 (以时间戳方式计算, 秒级)]
    // pushRemindTime({ publicTime, remindTime }) {
    //   return publicTime - remindTime * 60;
    // },
    // // 提醒时间前端显示 [试卷有效时间 - 提醒分钟数 (以时间戳方式计算, 秒级)]
    // pullRemindTime({ publicTime, remindTime }) {
    //   return (publicTime - remindTime) / 60;
    // },
  },
};
</script>
<style scoped lang="scss">
.public-View {
  width: 100%;
  // height: 100%;
  // padding: 0 24px;
  position: relative;
  overflow: auto;
  .public-goback {
    position: relative;
    // height: 80px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #303133;
    .public-goback-img {
      position: absolute;
      top: 12.5px;
      left: 0;
      width: 24px;
      height: 24px;
      transform: rotateY(180deg);
    }
    .public-goback-return {
      position: absolute;
      top: 17px;
      width: 44px;
      height: 22px;
      left: 28px;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #606266;
      letter-spacing: 0;
      cursor: pointer;
    }
    .public-goback-return:hover {
      color: rgb(47, 150, 255);
    }
  }
}
::v-deep.form_box {
  margin-top: 50px;
  .row {
    display: block;
  }
  .short-margin-bottom {
    margin-bottom: 8px;
  }
  .long-margin-right {
    margin-right: 64px;
  }
  .el-form-item {
    .el-form-item__label {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #313233;
      letter-spacing: 0;
    }
    .short-input {
      display: inline;
      .el-input__inner {
        width: 100px;
      }
    }
    .middle-input {
      .el-input__inner {
        width: 300px;
      }
    }
    .long-input {
      .el-input__inner {
        width: 600px;
      }
    }
  }
  .label-box {
    display: inline-block;
    overflow: hidden;
    .el-col {
      float: none;
    }
    .edit-label {
      margin-bottom: 16px;
      .el-form-item__label {
        width: 108px;
      }
    }
  }
  .el-form-item.is-required {
    &:not(.is-no-asterisk) {
      > .el-form-item__label {
        &:before {
          content: '';
          width: 0px;
          margin-right: 0px;
        }
      }
    }
  }
}

.save_button {
  margin-top: 50px;
  float: left;
  text-align: center;
  > .el-button {
    width: 100px;
  }
}
</style>
